<img #profileImage
     class="rounded-circle img-fluid img-thumbnail"
     [width]="this.width"
     [height]="this.height"
     alt="usr"
     [style.max-height]="this.height.toString() + 'px'"
     [style.max-width]="this.width.toString() + 'px'"
     [ngSrc]="url"
     (error)="errorHandler($event)"
     placeholder />
